import { render, staticRenderFns } from "./rows-edit-tab.vue?vue&type=template&id=87e2ef6a&scoped=true"
import script from "./rows-edit-tab.vue?vue&type=script&lang=js"
export * from "./rows-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./rows-edit-tab.vue?vue&type=style&index=0&id=87e2ef6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e2ef6a",
  null
  
)

export default component.exports